import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import styles from './scales.module.css';
import { setRegionCell } from '../../modules/scales/scaleValues';
import { resolveOptionImage } from '../../modules/scales/scaleImages';

/**
 * Tabela por região: uma linha por região do catálogo e uma lista por coluna
 * (ex.: quantidade e eritema das estrias). A primeira opção de cada lista é
 * "não avaliado", que limpa a célula. A região pode declarar `image` (como
 * as opções): aparece uma miniatura ao lado do nome (ex.: subtipos da rosácea).
 */
const ScaleRegionTable = ({ scale, value, onChange, readOnly, gender }) => {
  const regions = (value && value.regions) || {};
  const columns = scale.columns || [];

  return (
    <div className={styles.regions}>
      {(scale.regions || []).map((region) => {
        const row = regions[region.key] || {};
        const image = resolveOptionImage(region, gender);
        return (
          <div
            key={region.key}
            className={`${styles.regionRow} ${regions[region.key] ? styles.regionRowFilled : ''}`}
            style={{ '--columns': columns.length }}
          >
            <span className={styles.regionLabel}>
              {image && <img className={styles.regionImage} src={image} alt="" draggable={false} />}
              {region.label}
            </span>
            {columns.map((column) => {
              const labelId = `scale-${scale.key}-${region.key}-${column.key}`;
              return (
                <FormControl key={column.key} size="small" fullWidth disabled={readOnly}>
                  <InputLabel id={labelId}>{column.label}</InputLabel>
                  <Select
                    labelId={labelId}
                    label={column.label}
                    value={row[column.key] || ''}
                    onChange={(event) => onChange(setRegionCell(value, region.key, column.key, event.target.value))}
                  >
                    <MenuItem value=""><em>Não avaliado</em></MenuItem>
                    {column.options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ScaleRegionTable;
